import React from "react";
import { Navigate } from "react-router-dom";
import { getSessionStorage } from "src/helpers";

export function PrivateRoute({ children }) {
  const isLogin = getSessionStorage("authToken");
  return isLogin ? children : <Navigate to="/" />;
}
